import { Form, useFormikContext } from 'formik';
import * as Yup from 'yup';
import { makeStyles } from 'tss-react/mui';
import Button from '@mui/material/Button';
import RadioGroupField from '../forms/radio-group-field';
import FormSubmitStatus from '../forms/form-submit-status';

const useStyles = makeStyles()((theme) => ({
  submitButtons: {
    margin: theme.spacing(2, 0)
  }
}));

export const formSchema = Yup.object().shape({
  eventNotificationPreference: Yup.string()
    .oneOf(['ALL', 'NONE'])
    .required('Event notification preference is required'),
  postNotificationPreference: Yup.string()
    .oneOf(['ALL', 'FOLLOWING', 'NONE'])
    .required('Post notification preference is required'),
});

type Props = {
  disabled?: boolean;
  name?: string;
};

const GroupNotificationsForm = ({ disabled: formDisabled }: Props) => {
  const { isSubmitting } = useFormikContext();
  const { classes } = useStyles();
  const disabled = formDisabled || isSubmitting;

  return (
    <Form>
      <RadioGroupField
        name="eventNotificationPreference"
        label="Events"
        disabled={disabled}
        options={[
          {
            label: 'All new events',
            value: 'ALL',
          },
          {
            label: 'No new event notifications',
            value: 'NONE',
          },
        ]}
      />
      <RadioGroupField
        name="postNotificationPreference"
        label="Posts"
        disabled={disabled}
        options={[
          {
            label: 'New posts',
            value: 'FOLLOWING',
          },
          {
            label: 'New posts and comments',
            value: 'ALL',
          },
          {
            label: 'No new post or comment notifications',
            value: 'NONE',
          },
        ]}
      />

      <div className={classes.submitButtons}>
        <Button
          type="submit"
          disabled={disabled}
          color="primary"
          variant="contained"
        >
          Save
        </Button>
        <FormSubmitStatus />
      </div>
    </Form>
  );
};

export default GroupNotificationsForm;
